import { CSSProperties } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Icon = ({ width, height, style }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '25'}
      height={height || '18'}
      viewBox="0 0 25 18"
      style={style}
    >
      \
      <g fill="none" fillRule="evenodd">
        \
        <path
          stroke="#B7BEC8"
          strokeWidth="1.2"
          d="M20.574 9.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853z"
        />
        \
        <g stroke="#FEBD01" strokeLinecap="round">
          \
          <path d="M11.492 5.45a4 4 0 0 0-5.727 5.533" />\
          <path
            strokeWidth=".8"
            d="M9.707.973a.165.165 0 0 1 .19-.132c.09.016.15.097.133.19l-.304 1.723a.165.165 0 0 1-.19.132.161.161 0 0 1-.133-.189L9.707.973zm4.057 2.038a.165.165 0 0 1 .23.005.161.161 0 0 1-.002.23l-1.26 1.217a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.231l1.26-1.216zM3.43 13.415a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.23l1.26-1.217a.165.165 0 0 1 .23.005.161.161 0 0 1-.003.231l-1.26 1.216zM1.348 9.391a.165.165 0 0 1-.184-.14.161.161 0 0 1 .138-.185l1.734-.244a.165.165 0 0 1 .184.14.161.161 0 0 1-.138.185l-1.734.244zm.686-4.475a.165.165 0 0 1-.067-.22.161.161 0 0 1 .22-.07l1.547.823c.08.042.108.143.067.221a.161.161 0 0 1-.221.068l-1.546-.822zm3.193-3.215a.165.165 0 0 1 .076-.218.161.161 0 0 1 .219.074l.767 1.574c.04.08.003.18-.076.218a.161.161 0 0 1-.219-.074L5.227 1.7z"
          />
          \
        </g>
        \
      </g>
      \
    </svg>
  );
};

export default Icon;
